import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const bqGetGroupListForOwnerAdmin = async function(userId) {

  const app = firebase.app();
  const functions = getFunctions(app, 'asia-east2');
  const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

  const result = await queryThaisookViewBigQuery({
    info: 'get group list',
    query: `
    with data as (
        select 
          IF( U.role = 'superAdmin', 'superAdmin', 'groupAdmin') roleName
        from 
          thaisook_view.users U 
          where uid = '${userId}'
      )
      , supperAdminGroup as ( 
        select 
          G.groupId id,
          G.name,
          G.description,
          'superAdmin' as mk
        from 
          thaisook_view.groups G
      )
      , challangeGroup as (
        select
          GM.groupId id,
          G.name,
          G.description,
          'groupAdmin' as mk
        from
          thaisook_view.group_members GM
          join 
            thaisook_view.groups G
            on G.groupId = GM.groupId
        where
          GM.uid='${userId}'
          and GM.admin = true
      
        UNION ALL
      
        select
          G.groupId id,
          G.name,
          G.description,
          'groupAdmin' as mk
        from
          thaisook_view.groups G
        where
          G.owner = '${userId}'
      )
      , data5 as (
        select * from supperAdminGroup
        UNION ALL
        select * from challangeGroup
      )
      , data6 as (
        select groupId, count(1) member from thaisook_view.group_members GM group by groupId
      )
      select 
        id,
        name,
        data6.member,
        description
      from 
        data5
          join data
          on data5.mk=data.roleName
            left join data6
            on data5.id = data6.groupId
      order by member desc
      `
  });
  const resultObj = JSON.parse(result.data);
  return resultObj;  
};
export default bqGetGroupListForOwnerAdmin;
